export const colors = {
    timetableBorder: '#2574a9',
    timetableCellBorder: '#f0f2f5',
    timetableCellFull: '#89c4f4',
    timetableCellEmpty: '#00e640',
}